import { Image } from '@udemy/react-core-components';
import React from 'react';
import { SPOT_ILLUSTRATION_FILE_PATHS } from '../spot-asset-links';

/**
 *
 * @param cdnEnv - a string that is the base url for the CDN
 * @param name - the key of the SpotIllustration you want to render. @see {@link SpotIllustrationName}
 * @param colorScheme - the color scheme of the illustration to render. @see {@link SpotIllustrationProps}
 * @returns string of the srcSet to pass to the `Image` @see {@link Image} component
 */
export const getSpotIllustrationSrcSet = function (name) {
  let cdnEnv = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'prod';
  let colorScheme = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'light';
  return `${SPOT_ILLUSTRATION_FILE_PATHS[cdnEnv]}${colorScheme}/1x/${name}.webp 1x, ${SPOT_ILLUSTRATION_FILE_PATHS[cdnEnv]}${colorScheme}/2x/${name}.webp 2x`;
};
/**
 * ### SpotIllustration
 *
 * @remarks
 * Branded images that are in a space between `ExpressiveIcon` and `HeroIllustration`
 *
 * Renders an {@link Image Image} component with a `srcSet` attribute set up
 * to pull in 1x and 2x images from the CDN.
 */

export const SpotIllustration = _ref => {
  let {
    name,
    colorScheme = 'light',
    className,
    cdnEnv = 'prod',
    alt,
    width = 400,
    height = 400,
    ...props
  } = _ref;
  const { ...htmlProps
  } = props;
  const pictureSources = getSpotIllustrationSrcSet(name, cdnEnv, colorScheme);
  return /*#__PURE__*/React.createElement(Image, Object.assign({
    alt: alt,
    "aria-hidden": true,
    srcSet: pictureSources,
    className: className,
    width: width,
    height: height
  }, htmlProps));
};
//# sourceMappingURL=spot-illustration.react-component.js.map